import styled from "styled-components"
import PrimaryButton from "../../../components/Ui/Buttons/PrimaryButton"

export const AddButton = styled(PrimaryButton)`
  svg {
   position: relative;
    right: -1.5rem;
  }
`
